import { Box, Paper } from '@material-ui/core'
import useStyles from './Content.styled'

export const useContent = props => {
	const {
		className,
		image,
		isPaper,
		text,
		onImageClick,
		onTextClick,
		extraShortcuts,
		onClick,
		textEditable,
		onTextChange,
		textConfig,
		textKey,
	} = props

	const classes = useStyles(props)

	return [
		{
			classes,
			className,
			image,
			withImage: !!image?.image,
			isPaper,
			text,
			Element: isPaper ? Paper : Box,
			extraShortcuts,
			textEditable,
			textConfig,
			textKey,
		},
		{ onImageClick, onTextClick, onClick, handleTextChange: onTextChange },
	]
}
